import React from 'react';
import Container from './Container';


function App() {
    return (
        <div>
            <Container/>
        </div>
    );
}

export default App;
